import axios from "axios";
import { Product } from "../../products-page/models";
import { Filters } from "../../../models/filters.model";

export const getProductsForCategoryService = (categoryId: string, filters: Filters) => {
    return axios.post<Product[]>("products/" + categoryId + "?pickupPointId=" + filters.pickupPointId + "&productName=" + filters.productName + "&categoryId=" + filters.categoryId);
}